import { Database, Fingerprint, ShieldAlert } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import useOSINTTotals from '../../hooks/useOSINTTotals';

const formatNumber = (num: number): string => {
  return new Intl.NumberFormat('es-ES', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
    useGrouping: true, 
  }).format(num);
};

export default function OSINTStatisticsSection() {
  const { totals, loading, error } = useOSINTTotals();
  const { t } = useTranslation();

  if (loading) {
    return (
      <div className="py-16 text-center">
        <p className="text-lg text-gray-400 animate-pulse">
          {t('osint.loading')}
        </p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="py-16 text-center">
        <p className="text-lg text-red-500">{t('osint.error')}</p>
      </div>
    );
  }

  return (
    <section className="py-24 text-center">
      <div className="container mx-auto px-6 md:px-8 max-w-6xl">
        <h2 className="text-4xl md:text-5xl font-extrabold text-white">
          {t('osint.title')}
        </h2>

        {/* Grid sin recuadros */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-24">
          
          {/* Dehashed */}
          <div className="flex flex-col items-center">
            <Database className="h-16 w-16 text-red-400 mb-4" />
            <span className="text-5xl font-bold text-white">
              {formatNumber(totals?.dehashed_count ?? 0)}
            </span>
            <p className="text-xl text-gray-300 mt-2">{t('osint.leaks')}</p>
          </div>

          {/* IP Vulnerabilities */}
          <div className="flex flex-col items-center">
            <ShieldAlert className="h-16 w-16 text-yellow-500 mb-4" />
            <span className="text-5xl font-bold text-white">
              {formatNumber(totals?.ip_vulnerabilities_count ?? 0)}
            </span>
            <p className="text-xl text-gray-300 mt-2">{t('osint.vulnerable_ips')}</p>
          </div>

          {/* Typosquatting */}
          <div className="flex flex-col items-center">
            <Fingerprint className="h-16 w-16 text-blue-400 mb-4" />
            <span className="text-5xl font-bold text-white">
              {formatNumber(totals?.typosquatting_names_count ?? 0)}
            </span>
            <p className="text-xl text-gray-300 mt-2">{t('osint.typosquatting')}</p>
          </div>
        </div>

        {/* Texto adicional */}
        <p className="text-2xl text-gray-300 mt-20 max-w-2xl mx-auto">
          {t('osint.additional_info')}
        </p>
      </div>
    </section>
  );
}
